/**
 * Simplified Modal view that has no mask to obscure the application.
 * Sits on top of other elements/layers on the page.  Delivers a small
 * message to the user that requires user interaction to be closed or
 * given a small timeout duration before it closes itself.
 */
import { core } from '@glu/core';
import GluIcons from '@glu/icons';
import template from './notification.hbs';

const { LayerView } = core; // yes, this is really must be so.

const gluIconsInstance = new GluIcons({});
gluIconsInstance.registerIconHelper();

export default LayerView.extend({
  template,

  className: 'glu-notification-layer',

  initialize() {
    LayerView.prototype.initialize.call(this, this.options);
    this.message = this.options.message || '';
    this.type = this.options.type || 'default';
    this.duration = this.options.duration || false;
  },

  onRender() {
    if (this.duration) {
      const self = this;
      setTimeout(() => { // todo fix test/coverage here
        self.remove();
      }, this.duration);
    }
  },

  templateHelpers() {
    return {
      message: this.message,
      type: this.type
    };
  }
});
